module.exports = __webpack_public_path__ + "static/media/icon_IG.3a6bb9de.svg";